/** 公式値の入力 — 自社の台帳（編集中・審査待ち・公開済み）。 */
import { useEffect, useState } from "react";
import { EXPORT_CSV_URL, api, type MenuEntry, type ReviewState } from "../api";
import { Link } from "../router";
import { CATALOG_STATE_LABEL, REVIEW_STATE_LABEL, fmtDateTime, fmtNumber } from "../format";
import { StateChip } from "./parts";

const ORDER: ReviewState[] = ["pending_review", "editing", "published", "unpublished", "archived"];

export function Entries() {
  const [entries, setEntries] = useState<MenuEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void api.entries().then((r) => (r.ok ? setEntries(r.data) : setError(r.error)));
  }, []);

  return (
    <section className="stack-lg">
      <div className="row-between">
        <div>
          <h1>公式値の入力</h1>
          <p className="muted">
            入力した公式値の一覧です。新しく入力するときは <Link href="/catalog">掲載中のメニュー</Link> から品を選ぶか、Excel の一覧から
            まとめて取り込みます。
          </p>
        </div>
        <div className="actions">
          <Link href="/entries/bulk" className="btn primary">
            一覧で入力する（Excel から貼り付け）
          </Link>
        </div>
      </div>
      <div className="toolbar small">
        <a className="btn" href={EXPORT_CSV_URL}>
          御社の値を書き出す（CSV）
        </a>
        <Link href="/print" className="btn">
          印刷用の栄養成分表 <span className="badge trial">試用</span>
        </Link>
        <Link href="/public-page" className="btn">
          公開ページと QR <span className="badge trial">試用</span>
        </Link>
      </div>
      {error && <p className="error">{error}</p>}
      {!error && entries === null && <p className="muted">読み込んでいます…</p>}
      {entries && entries.length === 0 && (
        <div className="card">
          <p>まだ入力した公式値はありません。</p>
          <p>
            <Link href="/catalog" className="btn primary">
              掲載中のメニューから選ぶ
            </Link>
          </p>
        </div>
      )}
      {entries &&
        ORDER.map((state) => {
          // 改訂中 = 同じ商品に公開中の自社の値がある下書き
          const publishedProducts = new Set(entries.filter((e) => e.reviewState === "published").map((e) => e.productDbId));
          const rows = entries.filter((e) => e.reviewState === state);
          if (rows.length === 0) return null;
          return (
            <div key={state} className="card flush">
              <h2 className="card-title">
                {REVIEW_STATE_LABEL[state]} <span className="muted">{rows.length}</span>
              </h2>
              <ul className="list">
                {rows.map((e) => (
                  <li key={e.id} className="list-row">
                    <span>
                      <Link href={`/entries/${e.id}`} className="row-title">
                        {e.name}
                      </Link>
                      <span className="muted small">
                        {" "}
                        {fmtNumber(e.nutrition.cal, "kcal")} ・ 更新 {fmtDateTime(e.updatedAt)}
                      </span>
                    </span>
                    <span className="chips">
                      {/* 紐付け先が外れたことは公開済み・編集中・審査待ちのどれでも言う（公開停止・保管の行はもう関係ない） */}
                      {(e.catalogState === "gone" || e.catalogState === "leaving") &&
                        e.reviewState !== "unpublished" &&
                        e.reviewState !== "archived" && (
                          <StateChip state={`catalog-${e.catalogState}`} label={CATALOG_STATE_LABEL[e.catalogState].chip} />
                        )}
                      {e.reviewState !== "published" && e.status === "draft" && publishedProducts.has(e.productDbId) && (
                        <StateChip state="revision" label="改訂" />
                      )}
                      {e.reviewState === "editing" && e.lastDecision?.event === "rejected" ? (
                        <StateChip state="rejected" label="差し戻し" />
                      ) : (
                        <StateChip state={e.reviewState} label={REVIEW_STATE_LABEL[e.reviewState]} />
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
    </section>
  );
}
